class Sofatutor.Classes.AssignmentConfirmationPopup
  constructor: ->
    @$goToMylearningGroupsButton = $('.js-my-learning-groups-button')
    @$finishedButton = $('.js-finished-assingment-button')
    @bindEvents()

  bindEvents: =>
    @$goToMylearningGroupsButton.on 'click', -> Sofatutor.tracking.amplitude.track('lg_go_to_overview')
    @$finishedButton.on 'click', -> Sofatutor.tracking.amplitude.track('lg_close_assign_popup')
